import { WSSelect } from "@wingspanhq/fe-component-library";
import { IRequirementDefinitionResponse } from "@wingspanhq/payments/dist/interfaces";
import React from "react";

type Props = {
  requirementDefinition: IRequirementDefinitionResponse;
  value: number;
  onChange: (version: number) => void;
};

export const SelectRequirementDefinitionVersion: React.FC<Props> = ({
  onChange,
  requirementDefinition,
  value
}) => {
  const { version: latestVersion, versionHistory } = requirementDefinition;

  if (!versionHistory?.length) {
    return null;
  }

  const options = [
    { label: `v${latestVersion}`, value: String(latestVersion) },
    ...versionHistory.map(v => ({
      label: `v${v.version}`,
      value: String(v.version)
    }))
  ].sort((a, b) => Number(b.value) - Number(a.value));

  return (
    <WSSelect
      hideClearAction
      mode="single"
      options={options}
      style={{ width: "90px" }}
      value={String(value)}
      onChange={v => {
        if (v !== null) {
          onChange(Number(v));
        }
      }}
    />
  );
};
